import BaseAPIService from '../base/base-api-service';
import ProductModel from 'src/model/product.model';
import store from 'src/store';

class TopProductsService extends BaseAPIService<ProductModel> {
  public endpoint: string = '/navapp/v1/products/on-sale';

  constructor() {
    super(ProductModel);
  }

  public getTopProducts(size?: number): Promise<ProductModel[]> {
    return this.getByParams(this.endpoint, { size }, {});
  }
}

const topProductsServiceInstance = new TopProductsService();
Object.freeze(topProductsServiceInstance);

export default topProductsServiceInstance;
